// @flow
import React, { memo } from 'react'

import { Popover } from '../index'
import { Bool } from '../_formFields'

const PillowGaragedMiniApp = (props) => {
  const { content, miniAppData } = props
  const { discounts, setDiscounts } = miniAppData

  const handleOnChange = (value: boolean) => {
    setDiscounts(discounts.setIn(['CarPillow', 'garaged'], value))
  }

  return (
    <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center" key="pillowGaragedApp-content">
      <div className="col-10 col-sm-4 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right">
      </div>
      <div className="col-12 col-sm-5 order-3 order-sm-0 mt-2 mt-sm-0 pr-sm-0">
        <Bool
          enabled
          id="pillowGaragedApp"
          isPristine
          label={content.fieldNames.pillowGaragedLabel || ''}
          name="pillowGaraged"
          onChange={handleOnChange}
          prefix="pillow-"
          validationErrors={{}}
          value={discounts.getIn(['CarPillow', 'garaged'], false)}
        />
      </div>
      <div className="col-2 col-sm-3 order-0 order-sm-0 text-left">
        {miniAppData.inputHelps && miniAppData.inputHelps.pillowGaraged && miniAppData.inputHelps.pillowGaraged.content && (
          <Popover
            content={miniAppData.inputHelps.pillowGaraged.content}
            id="IDpillowGaraged"
            title={miniAppData.inputHelps.pillowGaraged.title}
          />
        )}
      </div>
    </div>
  )
}

export default memo(PillowGaragedMiniApp)
